import React, { useState, useContext, useEffect } from "react";
import { Row, Spinner, Alert } from "reactstrap";
import { useSelector } from "react-redux";
import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { DF_CO0003Context } from "../context";
import TableSimple from "../../../../components/Dynamic/TableSimple";
import CardContext from "../../../../components/Common/CardContext";
import CardFlow from "../../../../components/Common/CardFlow";
import NotificationModal from "../../../../components/Common/NotificationModal";
import CardContextExpansive from "../../../../components/Common/CardContextExpansive";
import ModalIframePage from "../../../../components/Common/ModalIframePage";
import ValidationDivergencyAlert from "../../../../components/Common/ValidationDivergencyAlert";

const COLUMN_LIST = [
  {
    field: "intNumero_Item",
    header: "Item",
    width: "10px",
    sort: true,
    align: "center",
  },
  {
    field: "strCodigo_Produto",
    header: "Cód. Prod.",
    width: "150px",
    sort: true,
  },
  {
    field: "strCodigo_Barras_Produto",
    header: "EAN",
    sort: true,
  },
  {
    field: "strDescricao_Produto",
    header: "Descrição Produto",
    sort: true,
  },
  {
    field: "dbQuantidade_Faturada",
    header: "Qtd.",
    sort: true,
  },
  {
    field: "strUnidade_Medida",
    header: "U.M.",
    sort: true,
  },
  {
    field: "dbValor_Unitario_Bruto_Produto",
    header: "Valor Unit. Brt.",
    sort: true,
  },
  {
    field: "dbValor_Total_Liquido_Produto",
    header: "Valor Total Brt.",
    sort: true,
  },
  {
    field: "strNumero_Pedido_Cliente",
    header: "N. do Pedido",
    input: true,
    width: "160px",
  },
  {
    field: "intItem_Pedido_Cliente",
    header: "Item do Ped.",
    input: true,
    width: "160px",
  },
  {
    field: "Coluna_Funcoes",
    header: "",
    width: "40px",
    hasImage: true,
  },
];

function GridBody() {
  const { parseParams, triggerOnFilter, setTriggerOnFilter } =
    useContext(DF_CO0003Context);
  const [dataContext, setDataContext] = useState([]);
  const [dataContextExpansive, setDataContextExpansive] = useState([]);
  const [dataFlow, setDataFlow] = useState([]);
  const [dataTableTwo, setdataTableTwo] = useState([]);
  const [dataTable, setDataTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [onlyErrorVisualization, setOnlyErrorVisualization] = useState(false);

  const ID_Arquivo = parseParams.get("ID_Arquivo");
  const [data, setData] = useState([]);

  const [details, setDetails] = useState([]);
  const [amountErroAlert, setamountErroAlert] = useState([]);
  const [status, setStatus] = useState({
    confirm: false,
    show: false,
    retry: false,
  });
  const [isInputEmpty, setIsInputEmpty] = useState(false);
  const [triggerType, setTriggerType] = useState("");
  const [openModalVisualization, setOpenModalVisualization] = useState(false);

  const [dataFirst, setDataFirst] = useState([]);
  const [hasBtnRevert, setHasBtnRevert] = useState(false);

  const { userProfile, access_token } = useSelector((state) => ({
    userProfile: state.login.profile,
    access_token: state.login.user.access_token,
  }));

  const csrfToken = useGetCsrfToken();

  const handleSave = async () => {
    try {
      const result = await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: userProfile.ID_Usuario,
        },
        "FRONT_Workspace_DF_CO0003_Enviar_Nota",
        csrfToken,
        access_token,
      );
      console.log("Resultado do envio: ", result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDataTableFirst = async () => {
    try {
      const result = await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: userProfile.ID_Usuario,
          3: "pt-BR",
        },
        "FRONT_Workspace_DF_CO0003_Itens",
        csrfToken,
        access_token,
      );
      if (result?.resultset_1?.length > 0) setDataFirst(result?.resultset_1);
      if (
        result?.resultset_2?.length > 0 &&
        result?.resultset_2[0]?.Botao_Desfazer_Split === "S"
      )
        setHasBtnRevert(true);
    } catch (error) {}
  };

  const handleValidateItem = async (isSimulate = true, filterErrors = null) => {
    setIsLoading(!isLoading);
    const result = await BizinBackend.executeProcedure(
      {
        1: ID_Arquivo,
        2: isSimulate ? "S" : "N",
        3: filterErrors ? "S" : null,
      },
      "FRONT_NotaFiscal_ValidarNFxPedido",
      csrfToken,
      access_token,
    );

    if (result?.resultset_1?.length > 0) setDataTable(result?.resultset_1);
    if (result?.resultset_2?.length > 0) setDetails(result?.resultset_2);
    if (result?.resultset_3?.length > 0 && result?.resultset_3[0])
      setamountErroAlert(result?.resultset_3);
    if (result?.resultset_4?.length > 0) setdataTableTwo(result?.resultset_4);
    setIsLoading(false);
  };

  const handleUpdadeOrSimulateItem = (item, isSimulate = true) => {
    setIsLoading(!isLoading);
    BizinBackend.executeProcedure(
      {
        1: ID_Arquivo,
        2: item?.intNumero_Item,
        3: item?.strNumero_Pedido_Cliente,
        4: item?.intItem_Pedido_Cliente,
        5: isSimulate ? "S" : "N",
      },
      "SRM_Atualizar_NumeroPed_ItemPed_Nota",
      csrfToken,
      access_token,
    ).finally(() => setIsLoading(false));
  };

  const validateItem = (item) => {
    if (!item?.strNumero_Pedido_Cliente || !item?.intItem_Pedido_Cliente) {
      return false;
    }
    return true;
  };

  const handleSimulate = async () => {
    const inputs = document.querySelectorAll("span.p-cell-editor-key-helper");
    let isInvalid = false;
    for (let i = 0; i < inputs.length; i++) {
      const source = inputs[i].textContent.trim();
      if (!source) {
        isInvalid = true;
        break;
      }
    }

    if (!isInvalid) {
      await handleValidateItem(true, onlyErrorVisualization);
    }
    if (isInvalid) setIsInputEmpty(true);
  };

  const handleData = async () => {
    try {
      const result = await BizinBackend.executeProcedure(
        {
          1: userProfile.ID_Usuario,
          2: "pt-BR",
          3: ID_Arquivo,
        },
        "FRONT_NotaFiscal_Obter_Resumo",
        csrfToken,
        access_token,
      );
      let formatterContext = result?.resultset_2?.map((item) => ({
        label: item.Coluna,
        value: item.Valor,
      }));

      let formatterContextExpansive = [];

      try {
        if (result?.resultset_3[0]?.Dados)
          formatterContextExpansive = JSON.parse(result?.resultset_3[0]?.Dados);
      } catch (error) {
        console.log("Erro ao formatar dados expansivos: ", error);
      }

      let formatterFlow = result?.resultset_1?.map((item) => ({
        name: item.Nome_Empresa,
        description: item.Descricao,
        logo: item?.Logo,
      }));

      setDataContext(formatterContext);
      setDataContextExpansive(formatterContextExpansive);
      setDataFlow(formatterFlow);
      setData(result);
    } catch (error) {
      console.log("Erro ao buscar dados de contexto: ", error);
    }
  };

  const handleRevertDivision = async () => {
    try {
      const result = await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: null,
          3: "D",
        },
        "FRONT_NotaFiscal_Desfazer_Split_Itens",
        csrfToken,
        access_token,
      );
      console.log("Resultado da reversão: ", result);
    } catch (error) {
      console.log("Erro ao reverter divisão: ", error);
    }
  };

  const handleCellEditComplete = (rowDataItem) => {
    handleUpdadeOrSimulateItem(rowDataItem);
  };

  const handleTriggers = (trigger) => {
    setOpenModalVisualization(true);
    setTriggerType(trigger);
  };

  const renderExpandedRow = (rowData) => {
    const filtered = details.filter(
      (item) => Number(item.Numero_Item) == Number(rowData.intNumero_Item),
    );

    let status = {
      I: {
        color: "#244EA2",
        textColor: "text-white",
        description: "A Nota Fiscal foi validada com sucesso",
      },
      E: {
        color: "#EC221F",
        textColor: "text-white",
        description: "Não foi encontrado o emissor da Nota Fiscal",
      },
      A: {
        color: "#FECE22",
        textColor: "text-color-azul1",
        description:
          "O peso bruto e o peso líquido não foram informados, por gentileza, verificar.",
      },
    };

    return (
      <>
        {filtered.map((item, k) => (
          <div
            key={k}
            style={{
              minHeight: 52,
              height: "auto",
              paddingLeft: 140,
            }}
            className={`validation-row ${
              item.Tipo_Mensagem === "I"
                ? "info"
                : item.Tipo_Mensagem === "E"
                  ? "error"
                  : "warning"
            } border border-end-0 border-start-0 border-color-cinza3`}
          >
            <div className="row p-0 m-0">
              <div className="col d-flex align-items-center gap-5">
                <div
                  className={`badge rounded-4 d-flex align-items-center px-3 ${status[item.Tipo_Mensagem].textColor} font-size-12 fw-semibold`}
                  style={{
                    background: status[item.Tipo_Mensagem].color,
                    height: 30,
                  }}
                >
                  Regra {item?.ID_Tipo_Validacao}
                </div>
                <div
                  className="text-color-cinza5 font-size-14"
                  dangerouslySetInnerHTML={{ __html: item?.Mensagem }}
                ></div>
              </div>
            </div>
          </div>
        ))}
      </>
    );
  };

  useEffect(() => {
    if (!data.length) handleData();
  }, [data]);

  useEffect(() => {
    if (!dataFirst.length) handleDataTableFirst();
  }, []);

  return (
    <>
      {isLoading && (
        <div className="loading-overlay">
          <Spinner color="primary" />
        </div>
      )}
      {status.show && !status.confirm && !status.revert && (
        <NotificationModal
          isOpen={status.show}
          type="warning"
          onClose={() => setStatus((state) => ({ ...state, show: false }))}
          onConfirm={() => {
            handleSave();
            setStatus((status) => ({ ...status, confirm: true }));
          }}
          confirmButton
          message="Esta ação salvará a Nota Fiscal conforme as informações inseridas na tabela."
        />
      )}
      {status.show && status.revert && (
        <NotificationModal
          isOpen={status.show}
          type="warning"
          onClose={() =>
            setStatus((state) => ({ ...state, show: false, revert: false }))
          }
          onConfirm={() => {
            handleRevertDivision();
            setStatus((status) => ({ ...status, confirm: true }));
          }}
          confirmButton
          message="Deseja realmente reverter a divisão nos itens?"
        />
      )}
      {status.show && status.confirm && status.revert && (
        <NotificationModal
          isOpen={status.show}
          type="success"
          onClose={() => {
            window.location.reload();
            setStatus((state) => ({ ...state, show: false, revert: false }));
          }}
          message="A divisão foi revertida com sucesso."
        />
      )}
      {status.show && status.confirm && !status.revert && (
        <NotificationModal
          isOpen={status.show}
          type="success"
          onClose={() =>
            setStatus((state) => ({ ...state, show: false, confirm: false }))
          }
          message="Operação realizada com sucesso!."
        />
      )}
      {status.show && status.retry && (
        <NotificationModal
          isOpen={status.show}
          type="warning"
          onClose={() => {
            setStatus((state) => ({ ...state, show: false, retry: false }));
            handleSimulate();
          }}
          message="As alterações serão perdidas, deseja prosseguir mesmo assim? ."
        />
      )}

      <Row className="align-items-center">
        {dataFlow?.length > 0 && (
          <div className="mb-3 col-12 col-lg-auto">
            <CardFlow flowData={dataFlow} />
          </div>
        )}

        {dataContext?.length > 0 && (
          <div className="mb-3 col">
            <CardContext data={dataContext} />
          </div>
        )}
        <div className="col-12 mb-3">
          <CardContextExpansive data={dataContextExpansive} />
        </div>
      </Row>

      {isInputEmpty && (
        <Alert color="warning">Todos os campos devem ser preenchidos.</Alert>
      )}

      {amountErroAlert.length > 0 && amountErroAlert[0] && (
        <ValidationDivergencyAlert
          onlyErrors={onlyErrorVisualization}
          totalText={`${amountErroAlert[0]?.Total_Itens_Divergentes} itens com divergência`}
          onVerify={() => {
            setOnlyErrorVisualization(true);
            handleValidateItem(true, true);
          }}
          onShowAll={() => {
            setOnlyErrorVisualization(false);
            handleValidateItem(true, false);
          }}
        />
      )}

      {dataTable?.length > 0 ? (
        <>
          <TableSimple
            data={dataTable}
            dataKey={"intNumero_Item"}
            columnsList={[
              {
                field: "Icone_Flag",
                header: "",
                width: "1%",
                hasImage: true,
              },
              ...COLUMN_LIST,
            ]}
            enableRowExpansion={details.length > 0}
            rowExpansionTemplate={renderExpandedRow}
            triggerOnFilter={triggerOnFilter}
            setTriggerOnFilter={setTriggerOnFilter}
            callbackCellEditComplete={handleCellEditComplete}
            callbackTriggers={handleTriggers}
          />
        </>
      ) : (
        <>
          {dataFirst.length > 0 && (
            <TableSimple
              dataKey={"intNumero_Item"}
              data={dataFirst}
              columnsList={COLUMN_LIST}
              rowExpansionTemplate={renderExpandedRow}
              triggerOnFilter={triggerOnFilter}
              setTriggerOnFilter={setTriggerOnFilter}
              callbackCellEditComplete={handleCellEditComplete}
              callbackTriggers={handleTriggers}
            />
          )}
        </>
      )}

      {dataTableTwo.length > 0 && (
        <TableSimple
          dataKey={"ID_Resultado"}
          data={dataTableTwo}
          columnsList={[
            {
              field: "Icone_Flag",
              header: "",
              hasImage: true,
              width: "3.5%",
              align: "end",
            },
            {
              field: "Icone_Regra",
              header: "Regra",
              hasImage: true,
            },
            {
              field: "Mensagem",
              header: "Descrição",
              width: "91%",
            },
          ]}
          rowExpansionTemplate={renderExpandedRow}
          triggerOnFilter={triggerOnFilter}
          setTriggerOnFilter={setTriggerOnFilter}
          callbackCellEditComplete={handleCellEditComplete}
          callbackTriggers={handleTriggers}
        />
      )}

      <div className="d-flex gap-2 align-items-center justify-content-end mt-3">
        <div className="d-flex gap-2 align-items-center">
          <button
            onClick={(e) => handleSimulate()}
            className={`btn bg-primary-dark-inverse fw-bold px-4`}
          >
            Simular Validações
          </button>
          {hasBtnRevert && (
            <button
              onClick={(e) =>
                setStatus((state) => ({ ...state, show: true, revert: true }))
              }
              className={`btn bg-primary-dark text-white fw-bold px-4`}
            >
              Reverter Divisão
            </button>
          )}
          <button
            onClick={(e) => setStatus((state) => ({ ...state, show: true }))}
            className={`btn fw-bold px-4 ${!amountErroAlert.length && dataTable.length > 0 ? "bg-primary-dark border border-primary-dark text-white" : "disabled bg-color-cinza2 text-color-cinza4 border border-color-cinza2"}`}
          >
            Salvar Alterações
          </button>
        </div>
      </div>

      <ModalIframePage
        openModal={openModalVisualization}
        onClosed={(withReload) => {
          setOpenModalVisualization(false);

          if (withReload) {
            setTriggerOnFilter(true);
          }
        }}
        triggerType={triggerType}
      />
    </>
  );
}

export default GridBody;
